import React, { useState } from "react"
import {
    TabContent,
    TabPane,
    Nav,
    NavItem,
    NavLink,
    Row,
    Col,
} from "reactstrap"
import classnames from "classnames"

import { TableTopHeading } from "components/TableTopHeading"
import WHInventoryManagementWI from "assets/images/warehouse/inventory-management/wh-inventory-management-icon.png"
import WarehouseChemicalInventListing from "./WarehouseChemicalInventListing"
import { getAppName } from "utils/commonUtils"
import WarehouseToolsInventListing from "./WarehouseToolsInventListing"
import WarehouseGeneralInventListing from "./WarehouseGeneralInventListing"

const WarehouseInventory = ({}) => {
    const [activeTabSecond, setActiveTabSecond] = useState("ic1")

    const toggle = tab => {
        if (activeTabSecond !== tab) {
            setActiveTabSecond(tab)
        }
    }

    let tabsConfig = [
        {
            title: "General Inventory",
            identifier: "ic1",
            content: <WarehouseGeneralInventListing />,
        },
        {
            title: "Chemicals",
            identifier: "ic2",
            content: <WarehouseChemicalInventListing />,
        },
        {
            title: "Tools",
            identifier: "ic3",
            content: <WarehouseToolsInventListing />,
        },
    ]
    return (
        <>
            <div className={"warehouse-nav-tabs"}>
                <TableTopHeading
                    title={`Warehouse Inventory (${getAppName()})`}
                    iconImage={WHInventoryManagementWI}
                    iconClass={"inventory-req-icon"}
                    className="mb-3"
                />

                <>
                    <Nav tabs className="border-0">
                        {tabsConfig &&
                            tabsConfig.map(el => {
                                return (
                                    <NavItem key={el.identifier}>
                                        <NavLink
                                            className={classnames({
                                                active:
                                                    activeTabSecond ===
                                                    el.identifier,
                                            })}
                                            onClick={() => {
                                                toggle(el.identifier)
                                            }}
                                        >
                                            {el.title}
                                        </NavLink>
                                    </NavItem>
                                )
                            })}
                    </Nav>
                    <TabContent activeTab={activeTabSecond}>
                        {tabsConfig &&
                            tabsConfig.map(el => {
                                return (
                                    <TabPane
                                        tabId={el.identifier}
                                        key={el.identifier}
                                    >
                                        <Row>
                                            <Col sm="12">
                                                {activeTabSecond ==
                                                    el.identifier && el.content}
                                            </Col>
                                        </Row>
                                    </TabPane>
                                )
                            })}
                    </TabContent>
                </>
            </div>
        </>
    )
}

export default WarehouseInventory
